import axios from 'axios';

const apiAtividadeStorage = axios.create({
  baseURL: process.env.REACT_APP_ORACLE_URL_UPLOAD_ATIVIDADE,
});

export default apiAtividadeStorage;
